module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('div', {
    staticClass: "grid-modified"
  }, [_c('ak-app-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "grid-main w-100 center pt4 pt0-xl ph3 mt3-ns mb55 max-w"
  }, [_c('router-view')], 1), _vm._v(" "), _c('ak-app-footer')], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63974723","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppBase.vue
// module id = 1266
// module chunks = 0